import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class UiInteractionService {
	private triggerAddReportPopSource = new Subject<void>();
	triggerAddReportPop$ = this.triggerAddReportPopSource.asObservable();

	emitAddReportPop() {
		this.triggerAddReportPopSource.next();
	}
}
